var map = {
	"./Group 22302.png": 1328,
	"./avatar-christmas.webp": 1329,
	"./bottom-bg-christmas.webp": 1330,
	"./btn-active.png": 1331,
	"./content-deco-1.webp": 1332,
	"./content-deco-2.webp": 1333,
	"./content-deco-3.webp": 1334,
	"./content-deco-4.webp": 1335,
	"./deco-3.webp": 1336,
	"./deposit-icon.webp": 1337,
	"./home-icon-active.webp": 1338,
	"./home-icon.webp": 1339,
	"./live-icon-active.webp": 1340,
	"./live-icon.webp": 1341,
	"./master-bg.jpg": 1342,
	"./master-bg.webp": 1343,
	"./me-icon-active.webp": 1344,
	"./me-icon.webp": 1345,
	"./platform.png": 1346,
	"./platform.webp": 1347,
	"./promos-icon-active.webp": 1348,
	"./promos-icon.webp": 1349,
	"./promos.webp": 1350,
	"./service-christmas.webp": 1351,
	"./snowman.webp": 1352,
	"./sponsor-icon-active.webp": 1353,
	"./sponsor-icon.webp": 1354,
	"./title-deco-left.webp": 1355,
	"./title-deco-right.webp": 1356,
	"./tree.webp": 1357,
	"./vip-icon.webp": 1358,
	"./vip.webp": 1359,
	"./withdraw-icon.webp": 1360,
	"./wwr-img.webp": 1361
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 108;